import React, { Component } from "react";

class ProductSliderV1 extends Component {
  render() {
    const publicUrl = process.env.PUBLIC_URL + "/";
    const { product } = this.props; // Receive the current product as prop

    if (!product || !product.sliderImg) {
      return null;
    }

    return (
      <div className="ltn__img-slider-area ">
        <div className="container-fluid">
          <div className="row ltn__image-slider-5-active slick-arrow-1 slick-arrow-1-inner ltn__no-gutter-all">
            
            {product.sliderImg?.map((img, imgIndex) => (
              <div className="col-lg-12" key={imgIndex}>
                <div className="ltn__img-slide-item-4">
                  <a
                    href={publicUrl + img.ImgUrl}
                    data-rel="lightcase:myCollection"
                  >
                    <img
                      src={publicUrl + img.ImgUrl}
                      alt={`${product.title} - Slide ${imgIndex + 1}`}
                    />
                  </a>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    );
  }
}

export default ProductSliderV1;